import useCam from '../../../hooks/useCam';
import { memo } from 'react';
const Cam = () => {
    useCam();
    return <></>;
};

export default memo(Cam);
